import Vue from 'vue';

/**
 * Follow a div down the page
 */
export default {
    bind(el, binding) {
        let blockOffsetTop = 0;

        Vue.nextTick(() => {
            blockOffsetTop = $(binding.value.inner).offset().top - window.scrollY;
        });

        $(window).scroll(() => {
            let header = $('header').outerHeight() || $('#mobile-logo').outerHeight() || 0;
            let offsetTop = $(el).offset().top;
            /**
             * Adds an extra 10px so the position of the block to make it look a bit prettier.
             * @type {number}
             */
            let borderOffset = 10;

            if (window.scrollY < (blockOffsetTop - header - borderOffset)) {
                return $(binding.value.inner).css({
                    top: `${0 - window.scrollY}px`,
                });
            }

            let summaryBase = offsetTop + $(el).outerHeight();
            const max = $(binding.value.container).offset().top + $(binding.value.container).outerHeight();

            $(binding.value.inner).css({
                top: `${(window.scrollY - offsetTop) + header + borderOffset}px`,
            });

            if ((summaryBase - blockOffsetTop) > max) {
                $(binding.value.inner).css({
                    top: `${max - (summaryBase - header)}px`,
                });
            }

        });
    }
}
